// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Portfolio Forecast",
    titleHelp: "Optional heading to display above the forecast",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showChart: "Show Chart",
    showChartHelp: "Display forecast line chart",
    showTable: "Show Table",
    showTableHelp: "Display statistics and projected values",
    compareWithBank: "Compare with bank savings",
    compareWithBankHelp:
      "Show a line for the same deposits at the collection's flat bank rate (rate set in the portfolio collection's calculation settings)",
    validationError: "At least one display option must be selected",
    validationErrorLong: "At least one display option (Chart or Table) must be selected",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Porteføljeprognose",
    titleHelp: "Valgfri overskrift som vises over prognosen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showChart: "Vis diagram",
    showChartHelp: "Vis prognoselinjediagram",
    showTable: "Vis tabell",
    showTableHelp: "Vis statistikk og forventede verdier",
    compareWithBank: "Sammenlign med banksparing",
    compareWithBankHelp:
      "Vis en linje for de samme innskuddene med samlingens flate bankrente (renten settes i porteføljesamlingens beregningsinnstillinger)",
    validationError: "Minst ett visningsalternativ må være valgt",
    validationErrorLong: "Minst ett visningsalternativ (diagram eller tabell) må være valgt",
  },
} as const;
